import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { AuthHelper } from '../../utils/authHelper';

interface LogoutModalProps {
  show: boolean;
  onHide: () => void;
  onConfirmLogout: (clearRememberMe: boolean) => void;
}

const LogoutModal: React.FC<LogoutModalProps> = ({ show, onHide, onConfirmLogout }) => {
  const [clearRememberMe, setClearRememberMe] = useState(false);
  const hasRememberMeData = AuthHelper.getRememberMeData() !== null;

  const handleConfirm = () => {
    onConfirmLogout(clearRememberMe);
    setClearRememberMe(false); // Reset for next time
  };

  const handleCancel = () => {
    setClearRememberMe(false);
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      centered
      className="logout-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Confirm Logout</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p className="mb-3">Are you sure you want to logout?</p>
          <p className="text-muted mb-3">You will need to sign in again to access your account.</p>
          
          {hasRememberMeData && (
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                id="clearRememberMe"
                label="Also forget my login information (clear Remember Me)"
                checked={clearRememberMe}
                onChange={(e) => setClearRememberMe(e.target.checked)}
              />
              <small className="text-muted">
                If checked, you'll need to enter your email address next time you login.
              </small>
            </Form.Group>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 gap-3">
        <Button
          variant="secondary"
          onClick={handleCancel}
          style={{ width: "30%", margin: "0" }}
        >
          Cancel
        </Button>
        <Button
          variant="danger"
          onClick={handleConfirm}
          style={{ width: "30%", margin: "0" }}
        >
          Logout
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogoutModal;